import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CommentForm from './CommentForm';
import './Comments.css';

const Comments = ({ postId }) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchComments = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
      const response = await axios.get(`${apiUrl}/api/comments/post/${postId}`);
      const commentsData = response.data.data;
      setComments(Array.isArray(commentsData) ? commentsData : []);
      setLoading(false);
    } catch (error) {
      // If there's an error, just set empty comments and stop loading
      setComments([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchComments();
  }, [postId]);

  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString('sr-RS', options);
  };

  return (
    <div className="comments-section">
      <h2>Komentari ({comments.length})</h2>
      
      {/* Show loading state */}
      {loading && (
        <div className="comments-loading">Učitavanje komentara...</div>
      )}

      {/* Show comments list or no comments message */}
      {!loading && (
        <div className="comments-list">
          {comments.length === 0 ? (
            <p className="no-comments">Trenutno nema komentara. Budite prvi koji će ostaviti komentar!</p>
          ) : (
            comments.map((comment) => (
              <div key={comment._id} className="comment">
                <div className="comment-header">
                  <span className="comment-author">{comment.author}</span>
                  <span className="comment-date">{formatDate(comment.createdAt)}</span>
                </div>
                <div className="comment-content">{comment.content}</div>
              </div>
            ))
          )}
        </div>
      )}

      {/* Always show the comment form after comments/no comments message */}
      {!loading && (
        <CommentForm postId={postId} onCommentSubmitted={fetchComments} />
      )}
    </div>
  );
};

export default Comments; 